export const CREATE_FEEDBACK_REQUEST: string = "CREATE_FEEDBACK_REQUEST";
export const CREATE_FEEDBACK_SERVICE_REQUEST: string =
  "CREATE_FEEDBACK_SERVICE_REQUEST";
export const CREATE_FEEDBACK_REPORT_ISSUE_REQUEST: string =
  "CREATE_FEEDBACK_REPORT_ISSUE_REQUEST";
